/**
 * Cleans-up array by removing identical entities.
 * @param duplicatedArray Array containing duplicate objects
 */
export function RemoveDuplicates<T>(duplicatedArray: T[]): T[] {
  const uniqueArray = duplicatedArray.filter((thing, index) => {
    const _thing = JSON.stringify(thing);
    return (
      index ===
      duplicatedArray.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      })
    );
  });
  return uniqueArray;
}

/**
 * Created deep-copy of the object.
 * @param obj Object to clone
 */
export function DeepClone<T>(obj: T): T {
  const str = JSON.stringify(obj);
  return JSON.parse(str) as T;
}

/**
 * Extracts number from string. All numbers found will be concatenated into one integer
 * @param input String containing number
 */
export function GetIntFromString(input: string) {
  try {
    return parseInt(input.match(/\d+/g)?.join("") ?? "");
  } catch {
    return 0;
  }
}

export function Intersection<T>(...arrays: Array<Array<T>>): T[] {
  return arrays.reduce((a, b) => a.filter(c => b.includes(c)));
}

/**
 * Redirect to provided URL if it's valid
 * @param targetUrl URL where user should be redirected
 */
export function RedirectToUrl(targetUrl: string) {
  try {
    if (!targetUrl) {
      throw new Error("Can not redirect to empty url");
    }
    const url = new URL(targetUrl, window.location.origin);
    window.location.href = url.href;
  } catch {
    console.error("Can not redirect to invalid URL: ", targetUrl);
  }
}

/**
 * Converts DateTime to Date object - removes time value, leaving only with Year, Month and Day
 * @param dateTime DateTime that should be processed
 */
export function GetDateFromDateTime(dateTime: any): Date | undefined {
  if (dateTime) {
    dateTime = (dateTime as Date) ?? null;
    return new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
  } else return undefined;
}

/**
 * Checks whether variable is function
 */
export function isFunction(variableToCheck: any) {
  return variableToCheck instanceof Function;
}

export function shouldFetchCarImage(brand?: string): boolean {
  const lowercaseBrand = brand?.toLowerCase();
  return lowercaseBrand === "volviaforetag" || lowercaseBrand === "volvia" || lowercaseBrand === "volviano";
}
